import { render, staticRenderFns } from "./ElementStudioPropertyPaths.vue?vue&type=template&id=149653f7&"
import script from "./ElementStudioPropertyPaths.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioPropertyPaths.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports